module.exports = "/_next/static/images/icon5-39e0282809f352e5c5e02a315d6fe86f.png";